import HTTPClient, { getDefaultHeaders } from '../../utils/HTTPClient';
import { application as OAUTH2 } from '../../utils/appData';

const getApiSocialService = social => `${OAUTH2.occBaseUri}/${OAUTH2.baseSiteId}/${social}`;

export const login = async (username, password, rememberMe, social, autologin) => {
    const body = new URLSearchParams();
    body.set('base_site', OAUTH2.baseSiteId);

    let grantType = 'password';

    if (social) {
        body.set('social_profile_provider_id', social.providerId);
        body.set('social_profile_access_token', social.accessToken);

        grantType = 'password_social_profile';
    }

    if (autologin) {
        grantType = 'social_profile';
    } else if (!username) {
        throw new Error('Login error: Empty username');
    } else {
        body.set('username', username);
        body.set('password', password);
    }
    body.set('grant_type', grantType);

    const clientId = rememberMe ? OAUTH2.rememberClientId : OAUTH2.clientId;
    body.set('client_id', clientId);

    const headerAuthCredentials = btoa(`${clientId}:${OAUTH2.clientSecret}`);

    const refreshParams = {
        method: 'POST',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: new Headers({
            ...getDefaultHeaders(),
            authorization: `Basic ${headerAuthCredentials}`,
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }),
        body: body.toString(),
    };
    const response = await fetch(OAUTH2.loginServerUri, refreshParams);
    const resBody = await response.json();

    if (!response.ok) {
        throw {
            json: resBody,
            status: response.status,
            message: response.message,
        };
    }
    return resBody;
};

export const logout = async () => {
    const response = await HTTPClient().get(OAUTH2.logoutServerUri);

    if (!response.ok) {
        throw new Error(`Unable to logout (${response.status})`);
    }
};

export const socialAuth = async payload => {
    const { socialUri, accessToken } = payload;
    const uri = `${getApiSocialService(socialUri)}`;
    const body = new URLSearchParams();
    body.set('accessToken', accessToken);
    const response = await HTTPClient().post(uri, body.toString());
    const resBody = await response.json();
    if (!response.ok) {
        throw {
            json: resBody,
        };
    }
    return resBody;
};
